<script setup lang="ts">
import { FormKit } from "@formkit/vue";
import { type PartnerResponse } from "mws-fabricks-ts-sdk";
import { ref } from "vue";

import BaseButton from "@/common/components/BaseButton.vue";
import PageWrapper from "@/common/components/PageWrapper.vue";
import PaginatedTable from "@/common/components/table/PaginatedTable.vue";
import type { TableColumn } from "@/common/components/table/types";
import { useListPartnersQuery } from "@/fabricks/partners/api/queries";
import PartnerCreateModal from "@/fabricks/partners/components/PartnerCreateModal.vue";

definePage({
  meta: {
    auth: ["FabricksAdmin.Access"],
  },
});

const createPartnerModalOpen = ref(false);

const columns: TableColumn<PartnerResponse>[] = [
  {
    key: "name",
    label: "Name",
    type: "link",
    pathConstructor: (item) => `/fabricks/partners/${item.id}/details`,
  },
  {
    key: "isEnabled",
    label: "Enabled",
    type: "bool",
  },
  {
    key: "dateCreated",
    label: "Date Created",
    type: "date",
  },
  {
    key: "name",
    label: "Platform",
    type: "link",
    pathConstructor: (item) => `/platforms/${item.platformId}/details`,
  },
];

const breadcrumbLinks = [
  {
    label: "Fabricks Partners",
    to: "#",
  },
];
</script>

<template>
  <PageWrapper
    :breadcrumb-links="breadcrumbLinks"
    title="Fabricks Partners"
  >
    <template #actions>
      <BaseButton
        variant="primary"
        label="Create"
        data-test="create-partner-button"
        @click="createPartnerModalOpen = true"
      />
    </template>
    <PaginatedTable
      :collection-query-fn="useListPartnersQuery"
      :collection-options="{ initialFilters: { includeDisabled: false } }"
      :columns="columns"
      :is-searchable="true"
    >
      <template #filters="{ filters }">
        <FormKit
          v-model="filters.includeDisabled"
          data-test="include-disabled-filter"
          label="Include Disabled Partners"
          name="includeDisabled"
          type="checkbox"
        />
      </template>
    </PaginatedTable>

    <PartnerCreateModal v-model:is-open="createPartnerModalOpen" />
  </PageWrapper>
</template>
